const childIdsOf = (sections, parentId) =>
  sections.filter((section) => section.parent_section_id === parentId).map((section) => section.id);

export const parentCheckState = (sections, selectedIds, parentId) => {
  const childIds = childIdsOf(sections, parentId);
  const parentSelected = selectedIds.has(parentId);
  const selectedChildCount = childIds.filter((id) => selectedIds.has(id)).length;

  if (parentSelected && selectedChildCount === childIds.length) return "checked";
  if (parentSelected || selectedChildCount > 0) return "indeterminate";
  return "unchecked";
};

export const toggleSectionSelection = (sections, selectedIds, sectionId) => {
  const next = new Set(selectedIds);
  const section = sections.find((row) => row.id === sectionId);
  if (!section) return next;

  const childIds = childIdsOf(sections, sectionId);
  if (!section.parent_section_id) {
    const fullySelected = next.has(sectionId) && childIds.every((id) => next.has(id));
    if (fullySelected) {
      next.delete(sectionId);
      childIds.forEach((id) => next.delete(id));
    } else {
      next.add(sectionId);
      childIds.forEach((id) => next.add(id));
    }
    return next;
  }

  if (next.has(sectionId)) {
    next.delete(sectionId);
    next.delete(section.parent_section_id);
  } else {
    next.add(sectionId);
  }
  return next;
};

export const toggleSelectAll = (sections, selectedIds) => {
  const allIds = sections.map((section) => section.id);
  const allSelected = allIds.length > 0 && allIds.every((id) => selectedIds.has(id));
  return allSelected ? new Set() : new Set(allIds);
};

export const idsToDelete = (sections, selectedIds) => {
  const removeIds = new Set(selectedIds);
  sections.forEach((section) => {
    if (section.parent_section_id && removeIds.has(section.parent_section_id)) {
      removeIds.add(section.id);
    }
  });
  return removeIds;
};

export const pruneSelection = (sections, selectedIds) => {
  const liveIds = new Set(sections.map((section) => section.id));
  return new Set([...selectedIds].filter((id) => liveIds.has(id)));
};
